import {
  ObjectType,
  defaultLoad,
  mediaUploadProcess,
} from 'components/forms/fields/file-upload-field/file-upload-field.utils';
import FileUploadField, {
  FileUploadFieldProps,
} from 'components/forms/fields/file-upload-field/file-upload-field.component';

type DisplayInformationImageUploadFieldProps = {
  objectType?: ObjectType;
} & Omit<FileUploadFieldProps, 'process'>;

const DisplayInformationImageUploadField = ({
  name,
  objectType,
  FilePondProps,
  ...rest
}: DisplayInformationImageUploadFieldProps) => {
  return (
    <FileUploadField
      name={name}
      process={mediaUploadProcess(name, objectType)}
      load={defaultLoad(id => id, { cache: 'no-cache' })}
      FilePondProps={{
        allowFileSizeValidation: true,
        maxFileSize: '400KB',
        allowImagePreview: true,
        allowFilePoster: false,
        acceptedFileTypes: ['image/*'],
        ...FilePondProps,
      }}
      {...rest}
    />
  );
};

export default DisplayInformationImageUploadField;
